import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import Select from 'react-select'
import Swal from 'sweetalert2'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Spinner from 'react-bootstrap/Spinner'

interface ProductEditModalProps {
	show: boolean;
	handleClose: (saved?: boolean) => void;
	product: any;
}

const ProductEditModal: React.FC<ProductEditModalProps> = ({ show, handleClose, product }) => {

	const [categories, setCategories] = useState<any[]>([]);
	const [selectedCategory, setSelectedCategory] = useState<any>(null);
	const [productName, setProductName] = useState('');
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (show && product) {
			setProductName(product.productName || '');
			fetch(process.env.REACT_APP_API_URL + 'product-categories', getRequestOptions())
				.then((resp) => resp.json())
				.then((resp) => {
					const options = resp.map((item: any) => ({
						label: item.category_name,
						value: item.id_product_categories,
					}));
					setCategories(options);

					if (product?.idCategories) {
						const current = options.find((opt: any) => Number(opt.value) === Number(product.idCategories));
						setSelectedCategory(current || null);
					}
				})
				.catch((error) => {
					console.log(error, 'Error fetching product categories');
				});
		}
	}, [show, product]);

	const handleSave = async () => {
		if (!selectedCategory) {
			Swal.fire({ icon: 'warning', title: 'Validation', text: 'Please select a category.' });
			return;
		}
		if (!productName.trim()) {
			Swal.fire({ icon: 'warning', title: 'Validation', text: 'Product name is required.' });
			return;
		}

		setLoading(true);
		try {
			const response = await fetch(
				`${process.env.REACT_APP_API_URL}products/update/${product.idProducts}`,
				postRequestOptions({
					productName: productName,
					idCategories: selectedCategory.value,
				})
			);
			const respData = await response.json();
			if (respData.success) {
				Swal.fire({ icon: 'success', title: 'Success', text: respData.successMessage });
				handleClose(true);
			} else {
				Swal.fire({ icon: 'error', title: 'Error', html: respData.errorMessage || 'Could not update product.' });
			}
		} catch (error) {
			console.log(error);
			Swal.fire({ icon: 'error', title: 'Error', text: 'Something went wrong.' });
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal show={show} onHide={() => handleClose(false)} size="lg" centered>
			<Modal.Header closeButton>
				<Modal.Title>Edit Product {product?.productName ? `- ${product.productName}` : ''}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form.Group className="mb-4">
					<Form.Label>Select Category</Form.Label>
					<Select
						value={selectedCategory}
						onChange={(option: any) => setSelectedCategory(option)}
						options={categories}
						placeholder="-- Select Category --"
						menuPosition="fixed"
					/>
				</Form.Group>
				<Form.Group className="mb-3">
					<Form.Label>Product Name</Form.Label>
					<Form.Control
						type="text"
						value={productName}
						onChange={(e) => setProductName(e.target.value)}
						placeholder="Enter product name"
					/>
				</Form.Group>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" size="sm" onClick={() => handleClose(false)}>
					Close
				</Button>
				<Button variant="primary" size="sm" onClick={handleSave} disabled={loading}>
					{loading && <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />}
					<span> Save</span>
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default ProductEditModal
